<template>
  <div class="pay">
    <div class="pay-header">
      <span>
        My Account:
        <em>{{ account }}</em>
      </span>
      <span>
        Balance:
        <em>RM{{ balance }}</em>
      </span>
      <a class="fr" @click="linkCardStockPay">
        Go to Coupon Reload
        <i class="iconfont iconyoujiantou"></i>
      </a>
    </div>
    <div class="pay-container">
      <div class="item">
        <p class="title">1.Choose your reload amount</p>
        <ul class="list">
          <li
            v-for="(item, index) in payList"
            :key="index"
            :class="[
              { active: index === currentIndex },
              { big: item.preferential === 0 },
            ]"
            @click="selectPrice(index)"
          >
            <img
              v-if="[2, 3, 4, 5].includes(index)"
              class="rec"
              src="@/assets/images/pay/rec.png"
              alt
            />
            <img class="cur" src="@/assets/images/pay/active.png" alt />
            <p class="text1">
              <em class="font-orange">RM{{ item.price }}</em>
            </p>
            <p class="text2" v-if="item.preferential > 0">
              Free <em class="font-red">RM{{ item.preferential }}</em>
            </p>
          </li>
          <li class="bg-gray">
            <p class="text3">For other package inquiry,</p>
            <p class="label">please contact our customer service team.</p>
          </li>
        </ul>
      </div>
      <div class="item">
        <p class="title">2.Choose payment method</p>
        <ul class="type-list">
          <li
            v-for="(item, index) in payType"
            :key="index"
            @click="selectPayType(index)"
            :class="{ active: index === payTypeIndex }"
          >
            <img
              style="width: 128px; height: 34px; margin: auto"
              :src="item.img1"
              alt
            />
            <img class="cur" :src="item.img" alt />
          </li>
        </ul>
      </div>
      <div class="item pay-btn-box">
        <el-button type="primary" @click="openPayPop">Reload</el-button>
        <a class="agree" @click="agreen">
          <el-radio v-model="agreeRadio" label="1">Read and agree</el-radio>
          <em>《Use statement》</em>
        </a>
      </div>
      <el-row class="item">
        <el-table :data="tableData">
          <el-table-column type="index" width="50"></el-table-column>
          <el-table-column label="Order ID" prop="batch"></el-table-column>
          <el-table-column
            label="Payment Method"
            :formatter="payFormat"
          ></el-table-column>
          <el-table-column
            label="Reload Amount"
            prop="payAmount"
          ></el-table-column>
          <el-table-column label="Reload Time" prop="payTime"></el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalSize"
          v-if="totalSize > 10"
        ></el-pagination>
      </el-row>
    </div>
    <Dialog
      :dialogVisible="dialogTableVisible"
      :dialogPaying="isPaying"
      :curPreferential="currentPreferential"
      :currentPrice="currentPrice"
      :showPrice="showPrice"
      :currentCouponId="currentCouponId"
      :currentPayType="currentPayType"
      @closeDialog="closePayPop"
      @onPay="changePay"
    />
    <DialogList
      :dialogVisible="dialogTableVisibleNew"
      @closeDialog="closeConstDetailPop"
    />
    <Accountdialog
      :dialogVisible="accountDialogTableVisible"
      @closeDialog="closeAccountDetailPop"
    />
  </div>
</template>

<script>
import Dialog from "./module/dialog.vue";
import { checkStatus } from "@/utils/checkout";
import { getSessionUser, inviteFriends } from "@/api/auth";
import { getChargeList } from "@/api/order";
import { userCouponList } from "@/api/coupon";
import { message } from "@/utils/resetMessage";
import DialogList from "../materialDownload/module/dialog.vue";
import Accountdialog from "../materialDownload/module/accountdialog";

// 支付方式映射
const PAY_WAY_MAP = new Map([
  [1, "Card"],
  [3, "WX"],
  [6, "Stripe"],
  [7, "BTC"],
]);

// 默认支付方式
const DEFAULT_PAY_WAY = "Alipay";

// 支付价格列表
const DEFAULT_PAY_LIST = [
  { price: 5, preferential: 0 },
  { price: 10, preferential: 0 },
  { price: 20, preferential: 2 },
  { price: 50, preferential: 5 },
  { price: 100, preferential: 15 },
  { price: 200, preferential: 35 },
  { price: 300, preferential: 60 },
  { price: 500, preferential: 150 },
  { price: 1000, preferential: 400 },
];

// 支付类型列表
const DEFAULT_PAY_TYPE = [
  {
    icon: "iconweixin",
    name: "stripe",
    code: "wechat",
    img: require("@/assets/images/pay/active3.png"),
    img1: require("@/assets/images/pay/stripe.png"),
  },
  {
    icon: "iconzhifubao",
    name: "BTC",
    code: "alipay",
    img: require("@/assets/images/pay/active3.png"),
    img1: require("@/assets/images/pay/PayPal.png"),
  },
];

// 错误消息配置
const ERROR_MESSAGES = {
  notLoggedIn: {
    message: "您还没登录用户，请登录",
    showClose: true,
    duration: 4000,
    offset: 100,
  },
};

export default {
  name: "PayPage",
  components: {
    Dialog,
    DialogList,
    Accountdialog,
  },
  data() {
    return {
      isLoggedIn: false,
      orderNum: "",
      userID: "",
      account: "",
      balance: "",
      payList: [],
      codeList: [],
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      totalSize: 0,
      currentIndex: 3,
      payTypeIndex: 0,
      currentPrice: 50,
      showPrice: 0,
      currentPreferential: 5,
      currentPayType: "wechat",
      dialogTableVisible: false,
      dialogTableVisibleNew: false,
      accountDialogTableVisible: false,
      payType: DEFAULT_PAY_TYPE,
      agreeRadio: "1",
      isPaying: false,
      userCouponList: [],
      currentCouponIndex: "",
      currentCouponPrice: 0,
      currentCouponId: 0,
      orderId: "",
      elements: "",
    };
  },
  mounted() {
    window.refeshTalbe = this.refeshTalbe;
    this.isLoggedIn = !!(
      this.$store.state.user.token &&
      this.$store.state.user.loginNameType != null
    );

    this.$EventBus.$on("constDetailOut", this.openConstDetailPop);
    this.$EventBus.$on("accountDetailOut", this.openAccountDetailPop);

    this.getUserList();
    this.getPayList();
    this.selectPrice(3);
    this.getTableData();
    this.$store.commit("updateShowAdvert", true);
    checkStatus();
  },
  beforeDestroy() {
    this.$EventBus.$off("constDetailOut", this.openConstDetailPop);
    this.$EventBus.$off("accountDetailOut", this.openAccountDetailPop);
    if (window.refeshTalbe === this.refeshTalbe) {
      delete window.refeshTalbe;
    }
  },
  methods: {
    // 刷新表格
    refeshTalbe() {
      this.getUserList();
      this.getPayList();
      this.selectPrice(3);
      this.getTableData();
    },

    // 支付方式格式化 - 使用 Map 优化
    payFormat(row) {
      return PAY_WAY_MAP.get(row.payWay) || DEFAULT_PAY_WAY;
    },

    // 获取用户信息
    async getUserList() {
      try {
        const result = await getSessionUser();
        this.$store.dispatch("setUserInfo", result);

        if (this.$store.state.user.loginNameType) {
          const { mobile, mail } = this.$store.state.common.userInfo;
          this.account = this.$store.state.user.loginNameType === 1 ? mobile : mail;
          this.balance = result.blance;

          try {
            const inviteResult = await inviteFriends();
            this.userID = inviteResult;
          } catch (error) {
            console.error("Get invite code error:", error);
          }

          this.orderNum = this.generateOrderNumber();
        }
      } catch (error) {
        console.error("Get user list error:", error);
      }
    },

    // 获取支付列表
    getPayList() {
      this.payList = [...DEFAULT_PAY_LIST];
    },

    // 选择价格
    selectPrice(index) {
      this.currentIndex = index;
      this.currentPrice = this.payList[index].price;
      this.currentPreferential = this.payList[index].preferential;

      // 设置第一个可用优惠券
      if (this.userCouponList && this.userCouponList.length > 0) {
        const validCoupon = this.userCouponList.find(
          (coupon) => this.currentPrice >= coupon.minAmount
        );
        if (validCoupon) {
          this.currentCouponIndex = this.userCouponList.indexOf(validCoupon);
          this.currentCouponPrice = validCoupon.typeMoney;
          this.currentCouponId = validCoupon.user_coupon_id;
        }
      }
    },

    // 选择优惠券
    selectCoupon(index) {
      const coupon = this.userCouponList[index];
      this.currentCouponIndex = index;
      this.currentCouponPrice = coupon.typeMoney;
      this.currentCouponId = coupon.user_coupon_id;
    },

    // 选择支付方式
    selectPayType(index) {
      this.payTypeIndex = index;
      this.currentPayType = this.payType[index].code;
    },

    // 前往卡券充值
    linkCardStockPay() {
      this.$router.push({ path: "/cardStockPay" });
      this.$store.commit("asideMenuId", 3);
    },

    // 同意使用声明
    agreen() {
      this.$router.push({ path: "/statement" });
      this.$store.commit("asideMenuId", 7);
    },

    // 生成订单号 - 优化后的实现
    generateOrderNumber() {
      const now = new Date();
      const pad = (num) => String(num).padStart(2, "0");
      const month = pad(now.getMonth() + 1);
      const day = pad(now.getDate());
      const hour = pad(now.getHours());
      const minutes = pad(now.getMinutes());
      const seconds = pad(now.getSeconds());
      const random = Math.round(Math.random() * 23 + 100);
      return `${now.getFullYear()}${month}${day}${hour}${minutes}${seconds}${random}`;
    },

    // 打开支付弹窗
    openPayPop() {
      if (!this.isLoggedIn) {
        message.error(ERROR_MESSAGES.notLoggedIn);
        return;
      }

      const selectedPrice = this.payList[this.currentIndex].price;
      this.showPrice = selectedPrice;

      // PayPal 和 Stripe 使用不同的费率
      const rate = this.payTypeIndex === 1 ? 1.039 : 1.03;
      const fee = this.payTypeIndex === 1 ? 2 : 1;
      this.currentPrice = parseFloat(selectedPrice * rate + fee).toFixed(2);

      this.dialogTableVisible = true;
    },

    closePayPop() {
      this.dialogTableVisible = false;
      this.getUserList();
      this.getPayList();
    },

    changePay(flag) {
      this.isPaying = flag;
      this.getTableData();
    },

    // 获取表格数据
    async getTableData() {
      const dataform = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        type: 3,
      };

      try {
        const result = await getChargeList(dataform);
        this.tableData = result.list;
        this.totalSize = result.count;
      } catch (error) {
        console.error("Get charge list error:", error);
      }
    },

    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.getTableData();
    },

    handleCurrentChange(val) {
      this.currentPage = val;
      this.getTableData();
    },

    // 获取用户优惠券
    async getUserCouponDatas() {
      try {
        const result = await userCouponList();
        if (result) {
          this.userCouponList = result;
        }
      } catch (error) {
        console.error("Get user coupon error:", error);
      }
    },

    // 费用明细
    openConstDetailPop() {
      this.dialogTableVisibleNew = true;
    },

    closeConstDetailPop() {
      this.dialogTableVisibleNew = false;
    },

    // 余额明细
    openAccountDetailPop() {
      this.accountDialogTableVisible = true;
    },

    closeAccountDetailPop() {
      this.accountDialogTableVisible = false;
    },
  },
};
</script>

<style lang="scss">
.pay-btn-box {
  .payment-element {
    margin-bottom: 24px;
  }
  .el-button {
    width: 110px;
    line-height: 44px;
    height: 44px;
    padding: 0;
    margin-bottom: 30px;
    text-align: center;
  }
  .agree {
    .el-radio {
      margin-right: 0;
    }
    .el-radio__input.is-checked + .el-radio__label {
      color: #8f8f8f;
      cursor: pointer;
    }
  }
}

button {
  background: #5469d4;
  font-family: Arial, sans-serif;
  color: #ffffff;
  border-radius: 4px;
  border: 0;
  padding: 12px 16px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  display: block;
  transition: all 0.2s ease;
  box-shadow: 0px 4px 5.5px 0px rgba(0, 0, 0, 0.07);
  width: 100%;

  &:hover {
    filter: contrast(115%);
  }

  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
}

.spinner,
.spinner:before,
.spinner:after {
  border-radius: 50%;
}

.spinner {
  color: #ffffff;
  font-size: 22px;
  text-indent: -99999px;
  margin: 0px auto;
  position: relative;
  width: 20px;
  height: 20px;
  box-shadow: inset 0 0 0 2px;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);

  &:before,
  &:after {
    position: absolute;
    content: "";
  }

  &:before {
    width: 10.4px;
    height: 20.4px;
    background: #5469d4;
    border-radius: 20.4px 0 0 20.4px;
    top: -0.2px;
    left: -0.2px;
    -webkit-transform-origin: 10.4px 10.2px;
    transform-origin: 10.4px 10.2px;
    -webkit-animation: loading 2s infinite ease 1.5s;
    animation: loading 2s infinite ease 1.5s;
  }

  &:after {
    width: 10.4px;
    height: 10.2px;
    background: #5469d4;
    border-radius: 0 10.2px 10.2px 0;
    top: -0.1px;
    left: 10.2px;
    -webkit-transform-origin: 0px 10.2px;
    transform-origin: 0px 10.2px;
    -webkit-animation: loading 2s infinite ease;
    animation: loading 2s infinite ease;
  }
}
</style>

<style rel="stylesheet/scss" lang="scss" scoped>
.font-orange {
  font-size: 26px;
  color: #ffae00;
}
.font-red {
  color: #ff4e00;
}
.font-red1 {
  font-size: 10px;
  color: #ff4e00;
}
.font-black {
  color: #393d49;
}
.pay {
  padding: 25px 40px 40px;
  margin-bottom: 20px;
  background: #fff;

  .pay-header {
    padding-bottom: 15px;

    span {
      color: #767676;

      em {
        color: #000;
        font-size: 16px;
      }

      &:nth-child(2) {
        margin-left: 15px;
      }
    }

    .fr {
      float: right;
      font-size: 14px;
      color: #909090;
      text-decoration: underline;
      cursor: pointer;
    }
  }

  .pay-container {
    .item {
      padding-top: 30px;
      border-top: 1px solid #e8e8e8;
      overflow: hidden;

      .title {
        padding-bottom: 30px;
        font-size: 14px;
        color: #767676;
      }

      .list {
        margin-bottom: 30px;
        overflow: hidden;

        li {
          margin-right: 10px;
          padding: 16px 16px 0;
          position: relative;
          float: left;
          width: 132px;
          height: 84px;
          border: 1px solid #e8e8e8;
          border-radius: 10px;
          text-align: center;
          font-size: 14px;
          cursor: pointer;
          margin-bottom: 10px;

          &.big {
            display: flex;
            justify-content: center;
            align-items: center;
          }

          &.bg-gray {
            display: block;
            height: 70px;
            padding: 30px 16px 0;
            background: #f3f3f3;
            color: #999;

            .label {
              padding-top: 5px;
              font-size: 12px;
              color: #c3c3c3;
            }
          }

          &.active {
            border: 1px solid #ff7a03;
            box-shadow: 1px 1px 10px #ffdcbd;

            .cur,
            .rec {
              display: block !important;
            }
          }

          .cur {
            position: absolute;
            right: 0;
            bottom: 0;
            display: none;
          }

          .rec {
            position: absolute;
            left: 0;
            top: 0;
            display: none;
          }

          .text1 {
            padding-bottom: 8px;
            color: #343851;
          }

          .text2 {
            padding-top: 8px;
            margin: 0 auto;
            margin-bottom: 10px;
            width: 80%;
            border-top: 1px solid #e8e8e8;
            color: #8e909b;
            font-size: 14px;
          }
        }
      }

      .couponlist {
        margin-bottom: 30px;
        overflow: hidden;

        li {
          margin-right: 10px;
          padding: 16px 16px 0;
          position: relative;
          float: left;
          width: 132px;
          height: 84px;
          border: 1px solid #ffdcbd;
          border-radius: 10px;
          text-align: center;
          font-size: 14px;
          cursor: pointer;
          margin-bottom: 10px;

          &.big {
            display: flex;
            justify-content: center;
            align-items: center;
          }

          &.bg-gray {
            border: 1px solid #9f9f9f;
            display: block;
            height: 70px;
            padding: 30px 16px 0;
            background: #f3f3f3;
            color: #999;

            .label {
              padding-top: 5px;
              font-size: 12px;
              color: #c3c3c3;
            }
          }

          &.active {
            border: 1px solid #ff7a03;
            box-shadow: 1px 1px 10px #ffdcbd;

            .cur,
            .rec {
              display: block !important;
            }
          }

          &.disabled {
            border: 1px solid #9f9f9f;
            pointer-events: none;
            opacity: 0.4;
            background: #eaeaea;
          }

          .cur {
            position: absolute;
            right: 0;
            bottom: 0;
            display: none;
          }

          .rec {
            position: absolute;
            left: 0;
            top: 0;
            display: none;
          }

          .text1 {
            padding-bottom: 8px;
            color: #343851;
          }

          .text2 {
            padding-top: 8px;
            margin: 0 auto;
            margin-bottom: 10px;
            width: 80%;
            border-top: 1px solid #e8e8e8;
            color: #8e909b;
            font-size: 14px;
          }

          .text3 {
            padding-bottom: 6px;
            color: #343851;
          }

          .text4 {
            padding-top: 6px;
            margin: 0 auto;
            margin-bottom: 2px;
            width: 80%;
            border-top: 1px solid #e8e8e8;
            color: #8e909b;
            font-size: 14px;
          }

          .text5 {
            color: #ff4e00;
            font-size: 10px;
          }
        }
      }

      .type-list {
        li {
          margin-right: 30px;
          position: relative;
          float: left;
          display: flex;
          width: 178px;
          height: 80px;
          line-height: 80px;
          border: 1px solid #e8e8e8;
          border-radius: 10px;
          color: #7d7d7d;
          font-size: 16px;
          flex-direction: row;
          justify-content: center;
          align-content: center;
          cursor: pointer;

          &:nth-child(2).active,
          &:nth-child(1).active {
            color: #666;

            .cur {
              display: block !important;
            }
          }

          &:nth-child(2).active {
            border: 1px solid #0c9ee0;
          }

          &:nth-child(1).active {
            border: 1px solid #0c9ee0;
          }

          &:nth-child(2) {
            color: #0c9ee0;

            .iconfont {
              margin-right: 6px;
              color: #0c9ee0;
            }
          }

          &:nth-child(1) {
            .iconfont {
              margin-right: 15px;
              color: #0c9ee0;
            }
          }

          .iconfont {
            font-size: 38px;
          }

          .cur {
            position: absolute;
            right: 0;
            bottom: 0;
            display: none;
          }
        }
      }
    }

    .text-item {
      margin-left: 20px;
      display: inline-block;

      .text1 {
        margin-top: 72px;
        font-size: 16px;

        .font-orange {
          font-size: 30px;
        }
      }

      .text2 {
        margin-top: 10px;
        font-size: 16px;
        color: #999;
      }

      .text3 {
        margin-top: 10px;
        font-size: 16px;
        color: #999;
      }
    }

    .pay-btn-box {
      margin-top: 30px;

      .agree {
        margin-left: 40px;
        cursor: pointer;

        .el-radio {
          margin-right: 0;
        }

        .el-radio__input.is-checked + .el-radio__label {
          color: #8f8f8f;
          cursor: pointer;
        }

        em {
          color: #2a2a2a;
          text-decoration: underline;
        }
      }
    }
  }
}
</style>
